<template>
  <div id="app">
    <div class="room" />
    <div class="text-wrapper">
      <h3 v-text="text" />
      <h4 v-text="subText" />
    </div>
    <div class="character-wrapper" :class="characterClass" @click="playAirhorn">
      <character :talking="character.talking" :laughing="character.laughing" :walking="character.walking" />
    </div>
    <div class="screen" :class="screenClass">
      <spectral-site />
    </div>
  </div>
</template>

<script>
import SpectralSite from './components/SpectralSite'
import Character from './components/Character'

export default {
  name: 'App',
  data() {
    return {
      text: '',
      subText: '',
      character: {
        talking: false,
        laughing: false,
        walking: false,
      },
      characterClass: undefined,
      screenClass: undefined,
      timer: {
        text: undefined,
        subText: undefined,
      }
    }
  },
  components: {
    Character,
    SpectralSite
  },
  created() {
    this.airhorn = new Audio('air-horn-meme.mp3')
    setTimeout(() => {
      this.screenFall()
      setTimeout(() => {
        this.characterWalk()
        setTimeout(() => {
          this.characterSpeech()
        }, 2500)
      }, 1500)
    }, 4000)
  },
  methods: {
    playAirhorn() {
      this.airhorn.pause()
      this.airhorn.currentTime = 0.1
      this.airhorn.play()
    },
    message(message, target = 'text') {
      this[target] = ''
      this.character.talking = true

      clearTimeout(this.timer[target])
      this.typeLetter(message.split(''), target)
    },
    typeLetter(letters, target) {
      this[target] += letters.splice(0, 1)
      this.timer[target] = setTimeout(() => {
        if (letters.length) {
          this.typeLetter(letters, target)
        } else {
          this.character.talking = false
        }
      }, 25)
    },
    screenFall() {
      this.screenClass = 'fall'
      setTimeout(() => {
        this.screenClass = 'fall slide'
      }, 1500)
    },
    characterWalk() {
      this.character.walking = true
      this.characterClass = 'closer'
      setTimeout(() => {
        this.character.walking = false
      }, 2000)
    },
    characterSpeech() {
      this.message('You fell right for my trap!')
      setTimeout(() => {
        this.character.laughing = true
        setTimeout(() => {
          this.character.laughing = false
          setTimeout(() => {
            this.message('My name is Spactrel, Spectral\'s evil brother!')
            setTimeout(() => {
              this.message('And you just got April Fooled!')
              setTimeout(() => {
                this.playAirhorn()
                this.character.laughing = true
                this.message('© An official Tristan Volk prank', 'subText')
              }, 750)
            }, 3500)
          }, 1500)
        }, 750)
      }, 750)
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

#app {
  position: fixed;
  top: 0;
  left: 0;
  perspective: 1000px;
  height: 100vh;
  width: 100vw;
}

.room {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;

  &:before {
    content: '';
    left: -50%;
    top: -10%;
    position: absolute;
    width: 200%;
    height: 200%;
    transform: translateZ(-1000px) rotate3d(1, 0, 0, 75deg);
    box-shadow: 0 0 250px 0 rgba(120, 160, 170, 0.1);
    border-radius: 15px;
  }
}

.text-wrapper {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: 'Bebas Neue', cursive;
  z-index: 5;
  top: 20%;
  flex-wrap: wrap;
  text-align: center;
  
  h3 {
    color: rgb(38, 38, 38);
    font-size: 42px;
    font-weight: 500;
    width: 100%;
    margin: 0;
  }
  
  h4 {
    color: rgba(38, 38, 38, 0.6);
    font-size: 23px;
    font-weight: 400;
    width: 100%;
    margin: 0;
  }
}

.character-wrapper { 
  position: absolute;
  bottom: 550px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 1;
  transform: translate3d(0, 0, -1300px);
  transform-origin: top center;
  perspective: 1000px;

  &.closer {
    transition: 2s;
    transition-timing-function: ease-in-out;
    transform: translate3d(0, 0, -800px);
    bottom: 450px;
  }
}

.screen {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate3d(1, 0, 0, 0deg);
  z-index: 2;

  &.fall {
    transition-duration: 1.5s;
    transition-timing-function: ease-in;
    transform-origin: bottom center;
    transform: rotate3d(1, 0, 0, 75deg);

    &.slide {
      transition-duration: 1.5s;
      transition-timing-function: ease-out;
      transform: translateZ(-50px) rotate3d(1, 0, 0, 75deg);
      z-index: 0;
    }
  }
}
</style>
